<template>
    <div>
        <md-field>
            <label class="field-placeholder-text">Your answer</label>
            <md-textarea
                :value="value"
                @keyup="onTextChanged($event.target.value), refreshWordCount($event.target.value)"
                class="textarea-large">
            </md-textarea>
            <span class="md-count">{{ wordCount }} of 500 words</span>
        </md-field>
        <md-snackbar
        md-position="center"
        :md-active.sync="saving"
        md-persistent
        >
        <span>Saving...</span>
        </md-snackbar>
    </div>
</template>

<script>
    import axios from 'axios';
    import _ from 'lodash';

    export default {
        name: 'QuestionText',
        props: ['value', 'studentWorkId', 'questionId'],
        data: () => ({
            wordCount: 0,
            saving: false
        }),
        methods: {
            async onTextChanged(text)
            {
                await this.captureTextChange(this.questionId, text);
            },
            async captureTextChange(questionId, text)
            {
                const url = `api/student-work/${this.studentWorkId}/questions/${questionId}/text`;
                var formData = new FormData();
                var wordCount = this.getWordCount(text);
                formData.append('wordCount', wordCount);
                formData.append('text', new Blob([text]));
                
                this.saving = true;
                
                try
                {
                    const response = await axios.put(url, formData, { headers: {'content-type' : 'multipart/form-data'} });
                }

                finally
                {
                    this.saving = false;
                }
            },
            refreshWordCount(text)
            {
                this.wordCount = this.getWordCount(text);
            },
            getWordCount(text)
            {
                var words = text.match(/\b[-?(\w+)?]+\b/gi) || [];
                return words.length;
            },
        },
        created() {
            this.onTextChanged = _.debounce(this.onTextChanged, 500, {
                leading: false,
                trailing: true,
            });
        }
    }
</script>

<style lang="scss" scoped>

  .md-field .md-textarea
  {
    max-height: 740px;
  }

  .textarea-large
  {
    min-height: 500px !important;
    height: 500px !important;
      text-align: justify;
      resize: none !important;
  }

  @media print {
  .textarea-large {
        min-height: 680px !important;
        height: 680px !important;
        border: 1px solid #9e9e9e !important;
        box-shadow: none !important;
        background: #fff !important;
        padding: 10px !important;
        line-height: 1.45;
  }

  ::v-deep .md-field::before,
  ::v-deep .md-field::after {
    display: none !important;
  }

  /* Hide the word count helper text on paper */
  .md-count {
    display: none !important;
  }

  .field-placeholder-text {
    display: none !important;
  }
}

</style>
